import {Screen} from '../../Common/stores/Screen';
import {PackagesCollection} from './PackagesCollection';

export class PackagesScreen extends Screen {
    constructor(screen, name) {
        super(screen, name);
        this.collection = new PackagesCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }
}
